export default function TeamSettings() {
    return (
        <div className="mt-4">
            <div className="rounded-lg border p-4">tenant URL subdomain, team logo, team name</div>
        </div>
    );
}
